export default [
    {
        path: '/online-magazine',
        props: true,
        component: () => import('@/views/OnlineMagazine'),
    },
];